function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinanceIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    id: "_003_ECOMMERCE_03",
    "data-name": "003_ECOMMERCE_03",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "003_099") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12,22a.99942.99942,0,0,1-1-1V3a1,1,0,0,1,2,0V21A.99942.99942,0,0,1,12,22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,13c-3.75684,0-6-1.68262-6-4.5S8.24316,4,12,4a6.42241,6.42241,0,0,1,5.34375,2.43457,1.00029,1.00029,0,0,1-1.6543,1.125A4.49724,4.49724,0,0,0,12,6c-1.8252,0-4,.43359-4,2.5S10.1748,11,12,11a1,1,0,0,1,0,2Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,20a6.42207,6.42207,0,0,1-5.34766-2.44043.99974.99974,0,0,1,1.6543-1.123A4.49754,4.49754,0,0,0,12,18c1.8252,0,4-.43359,4-2.5S13.8252,13,12,13a1,1,0,0,1,0-2c3.75684,0,6,1.68262,6,4.5S15.75684,20,12,20Z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceIcon);
export default __webpack_public_path__ + "static/media/financeIcon.f4645258b43f0156e97d3e24d193550a.svg";
export { ForwardRef as ReactComponent };